import type { IconProps } from 'common-types';

export const Female = ({ width = 18, height = 18, fill }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 18 18`}
    fill={fill ?? 'none'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M4.1001 6.77697C4.1001 3.77979 6.52979 1.3501 9.52697 1.3501C12.5241 1.3501 14.9538 3.77979 14.9538 6.77697C14.9538 9.77414 12.5241 12.2038 9.52697 12.2038C6.52979 12.2038 4.1001 9.77414 4.1001 6.77697ZM9.52697 3.1501C7.5239 3.1501 5.9001 4.7739 5.9001 6.77697C5.9001 8.78003 7.5239 10.4038 9.52697 10.4038C11.53 10.4038 13.1538 8.78003 13.1538 6.77697C13.1538 4.7739 11.53 3.1501 9.52697 3.1501Z" fill={fill ?? '#F14E52'}/>
    <path d="M9.5 11.25V15.75M12.5 13.5H6.5" stroke={fill ?? '#F14E52'} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
